import React, { Fragment } from "react";
import { Row, Col } from "react-bootstrap";
import DecaForm from "../../deca.form";
import DDadosItem from "@common/components/ddados/ddados.item";
import autoBind from "react-autobind";
import BaseComponent, { connect } from "@common/components/base.component";
import validacaoSolicitacaoActions from "../store/validacaoSolicitacao.actions";
import { ddadosValidacaoSolicitacao as DDados } from "../validacaoSolicitacao.ddados";
import ModalValidacao from "./deca.validacaosolicitacao.result";
import validacaoSolicitacaoSelector from "../store/validacaoSolicitacao.selectors";

class Container extends BaseComponent {
  constructor(props) {
    super(props, DDados);
    autoBind(this);
  }

  onSubmit(values) {
    this.props.validacaoSolicitacaoActions.validar(values);
  }

  render() {
    const { Titulo, Campos } = DDados;
    const { validacaoSolicitacao } = this.props.validacaoSolicitacaoSelector;
    const { onCancel, prefix } = this.props;

    return (
      <Fragment>
        <ModalValidacao show={validacaoSolicitacao.show} />
        <DecaForm
          onSubmit={this.onSubmit}
          boxForm={true}
          onCancel={onCancel || this.onCancel}
          initialValues={this.initialValues}
          prefix={prefix}
          title={Titulo}
          formControl={true}
        >
          <Row>
            <Col lg={4}>
              <DDadosItem
                name="NumeroSolicitacao"
                {...Campos.NumeroSolicitacao}
              />
            </Col>
            <Col lg={3}>
              <DDadosItem name="CpfCnpj" {...Campos.CpfCnpj} />
            </Col>
          </Row>
        </DecaForm>
      </Fragment>
    );
  }
}

export default connect({
  actions: {
    validacaoSolicitacaoActions
  },
  selectors: {
    validacaoSolicitacaoSelector
  }
})(Container);
